<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>
        <LoadOverlay :visible="overlay"></LoadOverlay>

        <b-input-group prepend="Nombre del documento" class="mt-3">
            <b-form-input v-model="name"></b-form-input>
            <b-input-group-append>
                <b-button v-on:click="buscar()" :disabled="habilitarBoton" variant="outline-success">Buscar</b-button>
            </b-input-group-append>
        </b-input-group>

        <b-form-group>
            <button v-on:click="clearFilter" type="button" class="btn btn-secondary button-limpiar mt-2">
                Limpiar filtro
            </button>
        </b-form-group>

    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import LoadOverlay from '@/components/shared/Load-overlay.vue'
import { applyDestinationFilter } from '@/plugins/complianceScripts/index.js'

export default {
    name: 'DocumentFilterName',

    data(){
        return{
            name: '',
            overlay: false,
            habilitarBoton: true,

            filter: {
                page: 1,
                pageSize: InitPageSize.DocumentPageSize
            },
        }
    },

    components: {
        AlertDismiss,
        LoadOverlay
    },

    computed:{
        ...mapGetters(["getRole"])
    },

    methods:{
        ...mapActions(["allDocumentByName"]),

        setOverlay(){
            this.overlay = ! this.overlay;
        },

        clearFilter() {
            this.name = '';
            this.$eventBus.$emit(EventNames.ClearFilterDocumen, this.filter);
        },

        async buscar(){
            this.setOverlay()

            let result =  await this.allDocumentByName({ 
                name: this.name,
                destination: applyDestinationFilter(this.getRole) })

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.setOverlay()
                return;
            }

            this.$eventBus.$emit(EventNames.FilterDocumentName, result);
            this.setOverlay();
        }
    },

    watch:{
        'name'(newValue){
            if(newValue != ''){
                this.habilitarBoton = false;
            }
            else{
                this.habilitarBoton = true;
            }
        }
    }

}
</script>
<style scoped>
.button-limpiar {
    --bs-btn-padding-y: .25rem;
    --bs-btn-padding-x: .5rem;
    --bs-btn-font-size: .75rem;
}
</style>